import {
  BloombergAnalyticsProvider,
  createBrowserHistoryPageTracker,
  initialize,
} from '@bbnpm/bb-analytics';
import { EnvironmentService } from '@ec/common';
import { MATOMO_CONFIG, MatomoConfiguration } from '../constants/analytics.constants';

interface IOptions {
  debug?: boolean;
  debugWarnOnly?: boolean;
}

export class AnalyticsUtils {

  static bbAnalyticsTrackPage = createBrowserHistoryPageTracker();

  private static getMatomoConfig(): MatomoConfiguration | null {
    const environmentService = new EnvironmentService( window.location );
    const currentEnvironment = environmentService.currentEnvironment();
    if ( !currentEnvironment ) {
      return null;
    }
    return MATOMO_CONFIG[ currentEnvironment.name ];
  }

  static initializeBbAnalytics( dimensions = {}, options: IOptions = {} ): boolean {
    const matomoConfig = AnalyticsUtils.getMatomoConfig();
    const defaultDimensions = {};
    const defaultOptions = { debug: false, debugWarnOnly: false };

    if ( !matomoConfig ) {
      return false;
    }

    return initialize( {
      provider: new BloombergAnalyticsProvider( matomoConfig.siteId, matomoConfig.environment, matomoConfig.internal, matomoConfig.namespaceDefinition ),
      dimensions: { ...defaultDimensions, ...dimensions },
      options: { ...defaultOptions, ...options },
    } );
  }

  static trackPage( path: string ) {
    AnalyticsUtils.bbAnalyticsTrackPage( path );
  }
}
